module.exports = __webpack_public_path__ + "img/writing-fluently.17b909e0.svg";